import { Component, ViewChild } from "@angular/core";
import { Observable, of, Subject } from "rxjs";
import { Agency_BranchGroupsProperties } from "../Models/Agency_BranchGroupsProperties";
import { Agency_BranchGroupService } from "../Services/agency_branch-group.service";
import { HttpClient } from '@angular/common/http'
import { Router } from "@angular/router";
import { Agency_Branches } from "../Models/ActiveClasses";
import { NgSelectComponent } from "@ng-select/ng-select";
declare var $;

@Component({
  selector: 'app-agency_branch-groups',
  templateUrl: './agency_branch-groups.component.html',
  styleUrls: ['./agency_branch-groups.component.css']
})
/** Agency_BranchGroups component*/
export class Agency_BranchGroupsComponent {
  /** Agency_BranchGroups ctor */
  constructor(private agencyService: Agency_BranchGroupService, private http: HttpClient,
    private router: Router) { }
  dataObj = new Agency_BranchGroupsProperties();
  agency_branchesList$: Observable<Agency_Branches[]>;
  agencyId: string = "";

  ngOnInit() {
    this.GetGroupBaseData();
  }
  GetGroupBaseData() {
    try {
      if ((localStorage.getItem("AgencyId") != undefined) && (localStorage.getItem("AgencyId") != ""))
        this.agencyId = (localStorage.getItem("AgencyId"));
      this.agencyService.GetAgency_BranchByParent(this.agencyId).subscribe((data) => {
        this.agency_branchesList$ = of(data);
        if ((localStorage.getItem("Agency_BranchGroupListID") != undefined) && (localStorage.getItem("Agency_BranchGroupListID") != "")) {
          let groupId = localStorage.getItem("Agency_BranchGroupListID");
          localStorage.removeItem("Agency_BranchGroupListID");
          this.agencyService.GetAgency_BranchGroupByID(groupId).subscribe((data) => {
            this.dataObj = data;
          })
        }
      })
    }
    catch (e) { }
  }

  CheckAdminValiations(): boolean {
    try {
      if (this.dataObj.name == "" || this.dataObj.immediateParent == "") {
        $("#lblerrormsg").show();
        document.getElementById("lblerrormsg").innerHTML = "Please Enter Required Fields."
        $("#lblerrormsg").delay(5000).hide(1000);
        return false;
      }
      if (this.dataObj.selectedItems.length == 0) {
        $("#lblerrormsg").show();
        document.getElementById("lblerrormsg").innerHTML = "Please Enter Required Fields."
        $("#lblerrormsg").delay(5000).hide(1000);
        return false;
      }
      else {
        return true;
      }

    }
    catch (e) {
      ////console.log (e);
    }
  }

  SaveData() {
    try {
      let userId = 0;
      if (localStorage.getItem("UserId") != undefined && localStorage.getItem("UserId") != null) {
        userId = Number(localStorage.getItem("UserId"))
        if (userId != 0) {
          this.dataObj.immediateParent = this.agencyId;
          if (this.CheckAdminValiations()) {
            if (this.dataObj.groupId != undefined && this.dataObj.groupId != null
              && this.dataObj.groupId != "") {
              this.dataObj.modifyUser = userId;
              this.agencyService.UpdateAgency_BranchGroups(this.dataObj).subscribe((data) => {
                if (data != false) {
                  this.router.navigateByUrl("/agency_BranchGroupList");
                }
                else {
                  $("#lblerrormsg").show();
                  document.getElementById("lblerrormsg").innerHTML = "Something went wrong."
                  $("#lblerrormsg").delay(5000).hide(1000);
                  return false;
                }
              })
            }
            else {
              this.dataObj.creationUser = userId;
              this.agencyService.CreateAgency_BranchGroups(this.dataObj).subscribe((data) => {
                if (data != false) {
                  this.router.navigateByUrl("/agency_BranchGroupList");
                }
                else {
                  $("#lblerrormsg").show();
                  document.getElementById("lblerrormsg").innerHTML = "Something went wrong."
                  $("#lblerrormsg").delay(5000).hide(1000);
                  return false;
                }
              })
            }
          }
        }
      }
    }
    catch (e) {

    }
  }


}
